import { render, staticRenderFns } from "./InputType.vue?vue&type=template&id=894e1b02&"
import script from "./InputType.vue?vue&type=script&lang=js&"
export * from "./InputType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('894e1b02')) {
      api.createRecord('894e1b02', component.options)
    } else {
      api.reload('894e1b02', component.options)
    }
    module.hot.accept("./InputType.vue?vue&type=template&id=894e1b02&", function () {
      api.rerender('894e1b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/InputType.vue"
export default component.exports